import { render } from "./SidenavCollapse.vue?vue&type=template&id=b705b33a"
import script from "./SidenavCollapse.vue?vue&type=script&lang=js"
export * from "./SidenavCollapse.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__